import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import FormikInput from '../../../../../../CommonComponents/FormikInput';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import { addIban } from '../../../../../ExperianActions';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import { Title } from '../../../ReportStyles';
import ExperianContext from '../../../../../ExperianContext';

const IbanForm = ({ onCancel, onRequestClose }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        iban: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addIban(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor IBAN</Title>
          <Label>
            <LabelText>IBAN</LabelText>
            <Field type="text" name="iban" component={FormikInput} size="small" />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

IbanForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default IbanForm;
